export default "__VITE_ASSET__FxAAiho7__ 400w, __VITE_ASSET__ZEvpZPVp__ 800w, __VITE_ASSET__CVC1BEj1__ 1024w";